import React, { useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import Iconify from "../../../components/Iconify";
import { useQuery, useMutation } from "@apollo/client";
import { FLUJO_DE_CAJA, ACTUALIZAR_FLUJO_CAJA } from "../../../graphql/bancos";
import Scrollbar from "../../../components/Scrollbar";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";

const TABLE_HEAD = [
  { id: "periodo", label: "Periodo" },
  { id: "saldo_inicial", label: "Saldo Inicial" },
  { id: "ingresos", label: "Ingresos" },
  { id: "egresos", label: "Egresos" },
  { id: "saldo_final", label: "Saldo Final" },
  { id: "", label: "" },
];

// Formatear valores como moneda (MXN)
const formatoMoneda = (valor) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(valor);

const FlujoCajaList = ({refetch }) => {
  const { data, loading, error } = useQuery(FLUJO_DE_CAJA);
  const [actualizarSaldoInicial] = useMutation(ACTUALIZAR_FLUJO_CAJA); // Hook para la mutación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editMode, setEditMode] = useState(null);
  const [saldoInicialEditado, setSaldoInicialEditado] = useState({});

   // Verifica si refetch se pasó correctamente
   if (!refetch) console.error("FlujoCajaList: refetch no está disponible");


  if (loading) return <h1>Cargando...</h1>;
  if (error) return <h1>Error al cargar datos</h1>;

  const { obtenerFlujoCaja } = data;

  // Manejar la actualización del saldo inicial
  const handleGuardarSaldo = async (id_flujo) => {
    const nuevoSaldo = parseFloat(saldoInicialEditado[id_flujo]);

    if (!isNaN(nuevoSaldo)) {
      try {
        await actualizarSaldoInicial({
          variables: {
            input: { id_flujo, saldo_inicial: nuevoSaldo },
          },
        });

        // Volver a cargar los datos para reflejar el cambio
        refetch();
      } catch (error) {
        console.error("Error al actualizar saldo inicial:", error);
      }
    }

    // Salir del modo edición
    setEditMode(null);
  };

  return (
    <>
      <Scrollbar>
        <Table>
          <MovimientosHeader headLabel={TABLE_HEAD} />
          <TableBody>
            {obtenerFlujoCaja
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const {
                  id_flujo,
                  periodo,
                  saldo_inicial,
                  ingresos,
                  egresos,
                  saldo_final,
                } = row;

                const puedeEditar = ingresos === 0 && egresos === 0 && saldo_final === 0;

                return (
                  <TableRow key={id_flujo}>
                    <TableCell>{periodo}</TableCell>
                    <TableCell>
                      {editMode === id_flujo ? (
                        <TextField
                          type="number"
                          value={saldoInicialEditado[id_flujo] || saldo_inicial}
                          onChange={(e) =>
                            setSaldoInicialEditado({
                              ...saldoInicialEditado,
                              [id_flujo]: e.target.value,
                            })
                          }
                          size="small"
                        />
                      ) : (
                        formatoMoneda(saldo_inicial)
                      )}
                    </TableCell>
                    <TableCell>{formatoMoneda(ingresos)}</TableCell>
                    <TableCell>{formatoMoneda(egresos)}</TableCell>
                    <TableCell>{formatoMoneda(saldo_final)}</TableCell>
                    <TableCell>
                      {editMode === id_flujo ? (
                        <Button
                          onClick={() => handleGuardarSaldo(id_flujo)}
                          startIcon={<Iconify icon="eva:checkmark-circle-2-outline" />}
                        >
                          Guardar
                        </Button>
                      ) : (
                        <Button
                          disabled={!puedeEditar}
                          onClick={() => setEditMode(id_flujo)}
                          startIcon={<Iconify icon="eva:edit-2-outline" />}
                        >
                          Editar
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Scrollbar>
    </>
  );
};

export default FlujoCajaList;
